import { useRealLocalStorage } from "components/shared/hooks/useLocalStorage";
import jwtDecode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backBtn from "assets/shared/hl-btn-back-left.png";
import useRandomCharacter from "utils/useRandomCharacter";
type FrameProps = {
  title: React.ReactNode;
  showBackBtn?: boolean;
  children?: React.ReactNode;
  onBackButtonClick?: Function;
  step?: string;
};

const Frame: React.FC<FrameProps> = ({
  children,
  title,
  showBackBtn = true,
  onBackButtonClick,
  step,
}) => {
  const url = useRandomCharacter();
  const [token, setToken, remove] = useRealLocalStorage("auth");
  const [error, setError] = useState<string | null>(null);
  const [user, setUser] = useState<null | any>(null);

  useEffect(() => {
    try {
      if (token) {
        const { user: inAuth } = jwtDecode(token) as any;
        setUser(inAuth);
      }
    } catch (error) {
      setError("There is an error!");
    }
  }, [token]);

  return (
    <div className="flex md:flex-row flex-col items-center justify-center w-full max-w-3xl">
      <div className="outer-frame animate__animated animate__fadeIn w-full">
        <div className="outer-fram-border">
          {step && (
            <div className="label__image">
              <h2 className="label__text">{step}</h2>
            </div>
          )}
          {showBackBtn && (
            <img
              src={backBtn}
              alt="hl-btn-back-left"
              className="back-btn"
              onClick={onBackButtonClick as React.ReactEventHandler}
            />
          )}
          <h1 style={{ fontWeight: "normal" }}>{title}</h1>
          <div className="frame-content">{children}</div>
        </div>
      </div>

      <img
        src={url}
        className="w-72 -mr-32 animate__animated animate__pulse animate__infinite animate__slower img-fluid"
        alt="Character"
      />
    </div>
  );
};

export default Frame;
